import { Copy, SquareArrowUpRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { ClientContactSchema } from '../client.schema';
import { z } from 'zod';
import { copyToClipboard, formatPhoneNumber } from '@/lib/utils';
import { capitalizeFirstLetter } from '@/lib/utils';

const ContactListContent = ({
  fullScreen,
  contacts,
  clientId,
}: {
  fullScreen: boolean;
  contacts: z.infer<typeof ClientContactSchema>['contacts'] | undefined;
  clientId: string;
}) => {
  const navigate = useNavigate();

  const displayedContacts = fullScreen ? contacts : contacts?.slice(0, 3);

  return (
    <div className="flex flex-col gap-4 px-6 py-4 ">
      {(displayedContacts ?? []).length > 0 ? (
        <>
          <div className={`${fullScreen ? 'grid grid-flow-row grid-cols-2' : 'grid grid-flow-row'} gap-4 w-full`}>
            {displayedContacts?.map((contact, index) => (
              <div key={index} className="flex flex-col bg-[#F5F5F5] break-all w-full gap-4 p-3 rounded-md">
                <div className="flex flex-col  items-left gap-2 justify-between">
                  <span className="text-sm font-semibold">
                    {contact.firstName ?? ''} {contact.lastName ?? ''}
                  </span>
                  <span className="text-[#969696] text-sm font-medium">{capitalizeFirstLetter(contact.type)}</span>
                </div>
                <div className="flex items-center justify-between gap-4 ">
                  <span className="text-sm text-[#3B82F6] max-w-[80%]">{contact.email}</span>
                  <Copy
                    className="cursor-pointer w-5 h-5 text-placeholder"
                    onClick={async () => {
                      await copyToClipboard(contact.email);
                    }}
                  />
                </div>
                {contact.phone && (
                  <div className="flex items-center  justify-between">
                    <span className="text-sm text-[#3B82F6] max-w-[80%]">{formatPhoneNumber(contact.phone)}</span>
                    <Copy
                      className="cursor-pointer w-5 h-5 text-placeholder"
                      onClick={async () => {
                        await copyToClipboard(formatPhoneNumber(contact.phone));
                      }}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="flex justify-end text-black">
            <Button
              variant={'outline'}
              onClick={() => navigate(`/clients/${clientId}/contacts`)}
              className=" border-[1px] border-primary px-[14px] py-[6px] flex gap-2 rounded-md w-[140px] h-[36px] text-primary font-medium"
            >
              <div className="flex items-center gap-2">
                <SquareArrowUpRight className="h-4 w-4" color="#0A2240" />
                <span className="text-sm">View Full List</span>
              </div>
            </Button>
          </div>
        </>
      ) : (
        <div className=" flex justify-center text-[#676767]">No Contacts</div>
      )}
    </div>
  );
};

export default ContactListContent;
